<template>
    <li v-if="$store.state.register.form.pay_rule.length > 0">
        <div class="title"><span>お支払い方法</span></div>
        <div class="detail">
            <p class="list_slash-separate">
                <span v-for="(pay_rule,index) in $store.state.register.form.pay_rule" v-bind:key="index">
                    {{pay_rule.name}}
                </span>
            </p>
        </div>
    </li>
</template>

